export default function Footer() {
  return (
    <div className="footer">
      <h4 className="footer-title">
        Improve your front-end skills by building projects
      </h4>
      <p className="footer-text">
        Scan the QR code to visit Frontend Mentor and take your coding skills to
        the next level
      </p>
    </div>
  );
}
